import { render, staticRenderFns } from "./DefaultSnacks.vue?vue&type=template&id=ce00e9b6&scoped=true&"
import script from "./DefaultSnacks.vue?vue&type=script&lang=js&"
export * from "./DefaultSnacks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce00e9b6",
  null
  
)

export default component.exports